import React, { useEffect, useRef, useState } from "react";
import { Overlay, Popover } from "react-bootstrap";

const HOVER_CLOSE_DELAY_MS = 200;

const PopoverStickOnHover = (props) => {
  const { delay, onMouseEnter, children, item, zIndex } = props;
  const [showPopover, setShowPopover] = useState(false);
  const childNode = useRef(null);
  const openTimeoutRef = useRef(null);
  const closeTimeoutRef = useRef(null);

  useEffect(
    () => () => {
      if (openTimeoutRef.current) clearTimeout(openTimeoutRef.current);
      if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
    },
    []
  );

  const cancelClose = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  };

  const handleMouseEnter = () => {
    cancelClose();
    openTimeoutRef.current = setTimeout(() => {
      setShowPopover(true);
      if (onMouseEnter) onMouseEnter();
    }, delay);
  };

  const handlePopoverMouseEnter = () => {
    cancelClose();
    setShowPopover(true);
  };

  const handleMouseLeave = () => {
    if (openTimeoutRef.current) {
      clearTimeout(openTimeoutRef.current);
      openTimeoutRef.current = null;
    }
    closeTimeoutRef.current = setTimeout(() => {
      setShowPopover(false);
      closeTimeoutRef.current = null;
    }, HOVER_CLOSE_DELAY_MS);
  };

  const handleClick = () => {
    setShowPopover(true);
  };

  const component = () => {
    return item;
  };

  const displayChild = React.Children.map(children, (child) =>
    React.cloneElement(child, {
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onClick: handleClick,
      ref: (node) => {
        childNode.current = node;
        const { ref } = child;
        if (typeof ref === "function") {
          ref(node);
        }
      },
    })
  )[0];

  return (
    <>
      {displayChild}
      <Overlay
        show={showPopover}
        placement='bottom'
        target={childNode}
        container={zIndex ? document.body : undefined}
        popperConfig={
          zIndex
            ? {
                strategy: "fixed",
                modifiers: [{ name: "offset", options: { offset: [0, 8] } }],
              }
            : undefined
        }
      >
        <Popover
          onMouseEnter={handlePopoverMouseEnter}
          onMouseLeave={handleMouseLeave}
          id='popover'
          style={
            zIndex
              ? { zIndex, position: "fixed", maxWidth: "min(420px, 96vw)" }
              : { maxWidth: "min(420px, 96vw)" }
          }
        >
          {component()}
        </Popover>
      </Overlay>
    </>
  );
};

PopoverStickOnHover.defaultProps = {
  delay: 0,
  onMouseEnter: () => {},
};

export default PopoverStickOnHover;
